import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import {convertDateToLocalDate, convertDateToInputDate} from "helpers/HelpDate";



const LineCrudTableRow = (
    {
        el,
        i,
        editData,
        deleteData,
        setFindModal,
        handleShow,
        listClientsByNumberLine,
        listClientsAll,
        setIdforLine
    }
) => {
    let myAbilities = HelpAbility();
    let {
        code,
        documentClient,
        number,
        type,
        numeroReportes,
        primerReporte,
        ultimoReporte,
        _id
    } = el;
    var typeFormat = "";
    var documentClientFormat = "";

    if (type === "hogar") {                          //para mostrar el tipo de linea en pag home
        typeFormat = "Hogar"
    } else if (type === "movilPrepago") {
        typeFormat = "Móvil Prepago"
    } else if (type === "movilPostpago") {
        typeFormat = "Móvil Postpago"
    }

    if (documentClient === "") {                     //para mostrar si una linea esta vinculada o no pag home
        documentClientFormat = "Línea no vinculada";
    } else {
        documentClientFormat = documentClient;
    }

    const handleChangeSelect = () => {              //click en "Gestión de Clientes"
        setFindModal();
        setIdforLine(el);                           //almaceno todo el obj de la linea seleccionada
        listClientsAll();                           //para modal segmento 2, listar todos los clientes con sus num de linea por cada uno
        listClientsByNumberLine(documentClient);    //prar modal segmento 3, listar el cliente vinculado a la linea
        handleShow();                               //abro el modal
    }

    return (
        <tr key={code}>
            <th className="text-center" scope="row">{i + 1}</th>
            <td className="text-center">{number}</td>
            <td className="text-center">{typeFormat}</td>
            <td className="text-center">{numeroReportes}</td>
            <td className="text-center">{convertDateToLocalDate(primerReporte)}</td>
            <td className="text-center">{convertDateToLocalDate(ultimoReporte)}</td>
            <td className="text-center">{documentClientFormat}</td>
            {myAbilities.hasAny([C.A.LINE.UPDATE, C.A.LINE.LINK, C.A.LINE.DELETE]) && <td className="text-center">
                {myAbilities.has(C.A.LINE.UPDATE) &&
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
                    <button type="button"
                            className="btn btn-sm btn-success me-2"
                            onClick={() => editData({
                                ...el,
                                primerReporte: convertDateToInputDate(primerReporte),
                                ultimoReporte: convertDateToInputDate(ultimoReporte)
                            })}>
                        <i className="bi bi-pencil-square"/>
                    </button>
                </OverlayTrigger>}
                {myAbilities.has(C.A.LINE.LINK) &&
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Gestión de Clientes</Tooltip>}>
                    <button type="button"
                            className="btn btn-sm btn-info me-2"
                            onClick={handleChangeSelect}>
                        <i className="bi bi-person-fill"/>
                    </button>
                </OverlayTrigger>}
                {myAbilities.has(C.A.LINE.DELETE) &&
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
                    <button type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => deleteData(_id)}>
                        <i className="bi bi-trash"/>
                    </button>
                </OverlayTrigger>}
            </td>}
        </tr>
    );
}
export default LineCrudTableRow;
